import { api } from './client';
import type { ListResponse, PaginationParams } from './types';

export interface ApDonatePreview {
  donate_type: string;
  donor_level: string;
  total_donated: string;
  unit_price: string;
  total_value: string;
  ap_available: string;
  fp_balance: string;
  uo_balance: string;
  fp_to_uo_ratio: string;
}

export interface ApDonateRecord {
  id: string;
  account_number: string;
  uo_credited: string;
  ref: string | null;
  memo: string | null;
  create_time: string;
}

export const apAPI = {
  donatePreview: () => api.get<ApDonatePreview>('/api/ap/donate-uo/preview'),

  donateMine: (params?: PaginationParams) =>
    api.get<ListResponse<ApDonateRecord>>('/api/ap/donate-uo/mine', params),

  donate: (body: {
    fp_amount: string;
    transaction_password: string;
    security_answer: string;
    memo?: string;
  }) => api.post<Record<string, unknown>>('/api/ap/donate-uo', body),
};
